import { useSiteContent } from '@/__lib/SiteContentProvider';
import { strings } from '@/i18n/strings';
import { CtaBand } from '@components/__shared/CtaBand/CtaBand';
import { Photo } from '@components/__shared/Photo/Photo';
import { RichText, hasRichTextContent } from '@components/__shared/RichText/RichText';
import { Seo } from '@components/__shared/Seo/Seo';
import styles from './Trainer.module.scss';

export const Trainer = () => {
	const { siteMeta, trainerContent } = useSiteContent();
	const { intro, trainers } = trainerContent;

	return (
		<>
			<Seo
				title={strings.trainer.seoTitle}
				description={strings.trainer.seoDescription(siteMeta.businessName, siteMeta.city)}
				path="/treneri"
			/>

			<section className={styles.intro}>
				<div className={styles.introInner}>
					{intro.eyebrow.trim() && <p className={styles.eyebrow}>{intro.eyebrow}</p>}
					<h1>{intro.headline}</h1>
					{hasRichTextContent(intro.body) && <RichText className={styles.introBody} html={intro.body} />}
				</div>
			</section>

			<section className={styles.team}>
				<div className={styles.teamGrid}>
					{trainers.map((trainer, index) => {
						const credentials = trainer.credentials.filter(credential => credential.trim());
						return (
							<article key={index} className={styles.trainerCard}>
								<Photo
									portrait
									src={trainer.photoSrc}
									alt={trainer.photoAlt}
									className={styles.trainerPhoto}
								/>
								<h2>{trainer.name}</h2>
								{trainer.role.trim() && <p className={styles.role}>{trainer.role}</p>}
								{hasRichTextContent(trainer.bio) && (
									<RichText className={styles.bio} html={trainer.bio} />
								)}
								{credentials.length > 0 && (
									<ul className={styles.credentials}>
										{credentials.map((credential, ci) => (
											<li key={ci}>{credential}</li>
										))}
									</ul>
								)}
							</article>
						);
					})}
				</div>
			</section>

			<CtaBand />
		</>
	);
};
